module.exports = __webpack_public_path__ + "static/media/icon-star.7dc0fc36.svg";